import React, { useMemo } from 'react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface CorrelationData {
  x: number;
  y: number;
}

interface CorrelationScatterChartProps {
  data: CorrelationData[];
  loading?: boolean;
}

const CorrelationScatterChart: React.FC<CorrelationScatterChartProps> = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="h-48 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const chartData = useMemo(() => 
    data.map(item => ({
      irradiance: Math.round(item.x),
      energy: Math.round(item.y)
    })), [data]);

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-slate-800/95 border border-slate-600/50 rounded-xl p-4 shadow-xl backdrop-blur-sm">
          <p className="text-violet-400 font-bold">
            Irradiance: {data.irradiance} W/m²
          </p>
          <p className="text-green-400 font-bold">
            Energy: {data.energy} kWh
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full h-48 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-4">
      <ResponsiveContainer width="100%" height="100%">
        <ScatterChart data={chartData}>
          <CartesianGrid strokeDasharray="2 2" stroke="#e2e8f0" opacity={0.3} />
          <XAxis 
            type="number"
            dataKey="irradiance"
            name="Irradiance"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <YAxis 
            type="number"
            dataKey="energy"
            name="Energy"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Scatter dataKey="energy" fill="#6366f1" />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CorrelationScatterChart;